"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistrationPageLink = void 0;
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_link_1 = require("@hotelplan/components.common.link");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const RegisterButtonLink_1 = require("./RegisterButtonLink");
const RegisterBaseLink = (0, styled_components_1.default)(components_common_link_1.Link).attrs({
    'data-id': `register-link`,
})(({ theme }) => theme.buttons.linkBtn, (0, util_theme_sxc_1.sx2CssThemeFn)({
    fontSize: 3,
    fontWeight: 600,
}));
function RegistrationPageLink(props) {
    const { className } = props;
    const [t, { language }] = (0, next_i18next_1.useTranslation)(['auth']);
    return (react_1.default.createElement(RegisterButtonLink_1.RegistrationRouterLink, { language: language },
        react_1.default.createElement(RegisterBaseLink, { className: className }, t('auth:register.button'))));
}
exports.RegistrationPageLink = RegistrationPageLink;
//# sourceMappingURL=RegistrationPageLink.js.map